// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/d190e6f5/" + chunkId + "." + __webpack_require__.h() + ".vd190e6f5.js";
};